import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_v58tcqg42w: FaireBrandEntity = {
  token: "b_v58tcqg42w",
  type: "brand",
  name: "Now N Zen",
  avatarUrl:
    "https://cdn.faire.com/fastly/06543b29078312a3ef23dbd11fba331aa4c2376dabaabef5e865fecb2df9354e.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4bdf77f1ada50f0c3623d430b61e030645ec3042b666536ad520529061893b1b.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/06543b29078312a3ef23dbd11fba331aa4c2376dabaabef5e865fecb2df9354e.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4bdf77f1ada50f0c3623d430b61e030645ec3042b666536ad520529061893b1b.jpeg",
  location: "Boulder, CO, USA",
  minimumOrderDollars: 208,
  rating: 5,
  reviewCount: 33,
  isInsider: true,
  description:
    'In 1999, Serenity Tibet was established by Suren and Ruby Shrestha, beginning with the sale of authentic Nepali sound healing bowls known for their calming and restorative properties. Over time, our collection grew to include a variety of sound instruments designed to enhance meditation\nand promote overall well-being. We are excited to introduce our new name: Now N Zen. This name reflects our core philosophy-embracing peace in the present moment. "Now" represents the importance of being fully present, while "Zen" signifies the tranquility and balance we seek to offer. Together, Now N Zen symbolizes finding immediate calm and peace through mindful living. At Now N Zen, we offer a diverse selection of meditation tools, from singing bowls to chimes, bells, and crystals. Each item is carefully chosen to support and enhance your meditation practice, whether you are just\nstarting or are a seasoned practitioner. We are committed to providing high-quality resources that help you achieve balance and tranquility. Based in Boulder, CO, with options available online worldwide, our goal is to support you in your journey to inner peace. Discover the harmony of the present moment with Now N Zen. Please, also check our sister company www.atmabuti.org where we provide educational classes on how to use the musical instruments from NowNZen for healing purpose.',
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:51.659Z",
    importedBy: "entity-db-cli",
  },
};
